import axios from "axios";
import APIURL from "../../Main/apiurl";

const uploadDocument = async (formData) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const response = await axios.post(
      `${APIURL}/upload-document`,
      formData,
      config
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { status: false, message: error.message };
  }
};

const getDocuments = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-documents`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { status: false, message: error.message };
  }
};

const getDocument = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-document`, data, config);
    return response.data;
  } catch (error) {
    return error.response?.data || { status: false, message: error.message };
  }
};

const deleteDocument = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/delete-document`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { status: false, message: error.message };
  }
};

const downloadDocument = async (documentId) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    };

    const response = await axios.get(
      `${APIURL}/download-document/${documentId}`,
      config
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", response.headers["content-disposition"]?.split("filename=")[1] || "document");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { status: true };
  } catch (error) {
    return { status: false, message: error.message };
  }
};

const viewDocument = async (documentId) => {
  try {

      let data = {
      id: documentId
    };

     const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-document`, data, config);

    if (response.data.status && response.data.data) {

      const viewUrl = `${APIURL}/view-document/${documentId}`;
      
      return {
        status: true,
        url: viewUrl,
        document: response.data.data
      };
    }

    return { status: false, message: "Document not found" };
  } catch (error) {
    return { status: false, message: error.message };
  }
};

const getDocumentStats = async () => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-document-stats`,
      {},
      config
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { status: false, message: error.message };
  }
};

export {
  uploadDocument,
  getDocuments,
  getDocument,
  deleteDocument,
  downloadDocument,
  viewDocument,
  getDocumentStats,
};